import { TableCell, TableRow } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'

export const StyledTableCell = withStyles(() => ({
  body: {
    fontSize: 14,
  },
}))(TableCell)

export const StyledTableRow = withStyles(() => ({}))(TableRow)

export default makeStyles((theme) => ({
  container: {
    ...theme.mundi.font.lato700Normal,
    fontSize: '15px',
    lineHeight: '18px',
    color: theme.palette.common.black,
  },
}))
